// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LoginBg,
.ResetBg,
.ForgotBg,
.SignUpBg {
    background-size: cover;
    width: 100%;
    min-height: 100vh;
}

.LoginBg>div,
.ResetBg>div,
.ForgotBg>div,
.SignUpBg>div,
.user-profile {
    min-height: calc(100vh - 68px);
}

.signupimgbg {
    background: rgba(20, 118, 255, .1);
}

.card {
    border-radius: 15px;
}


.phone-selectr{
    border: 1px solid rgb(233, 234, 243);
    border-radius: 30px;
    padding: 5px;
    box-shadow: rgb(233, 234, 243) 0px 0px 10px;
}

.FormDiv>input ::-ms-reveal {
    display: block !important;
}

.Forgot {
    font-style: normal;
    font-weight: 500;
    font-size: 13px;
    margin-bottom: 5px;
    border: none;
    background-color: transparent;
}

.Password {
    border: 1px solid black;
    border-radius: 30px;
    padding: 5px;
    overflow: hidden;
    width: 100%;
}

.Password>input {
    border: none;
    background: transparent;
    width: 86%;
}

.Password>button {
    border: none;
    background: transparent;
}

.Password>input:focus {
    border: none;
    outline: none;
}

.auth-error {
    font-size: 12px;
    font-weight: 600;
}
.nav-item > label {
    font-size: 14px;
}
.Button {
    border: none;
    background-color: #1476FF;
    color: #ffffff;
    text-align: center;
    width: 100%;
    margin-top: 20px;
    padding: 7px 0px;
    border-radius: 45px;
}

.Button:disabled {
    opacity: 0.5;
}

.OtpInputBox {
    display: flex;
    justify-content: center;
}
.OtpInputBox>input {
    border-radius: 10px;
    border: 1px solid black;
    height: 50px !important;
    width: 50px !important;
    -webkit-text-security: square;
}
.OtpInputBox1>input {
    font-size: 20px;
    border-radius: 10px;
    border: 1px solid black;
    height: 40px !important;
    width: 40px !important;
}
.resize:active {
    transform: scale(0.5);
}
.nav-item > .active {
    font-weight: 600;
    color: black !important;
}

/* .logindiv{
    border: none!important;

} */

.logindiv > div div:nth-child(2) > div{
    padding: 0px;
}


.restricted-modal > .modal-dialog{
    display: flex;
    justify-content: center;
    
}
.restricted-modal > .modal-dialog > .modal-content{
    width: 85% !important;
    border-radius: 30px;
}


.css-f6d81q-control{
    border: none;
    box-shadow: none;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Auth/AuthCss/Login.css"],"names":[],"mappings":"AAAA;;;;IAII,sBAAsB;IACtB,WAAW;IACX,iBAAiB;AACrB;;AAEA;;;;;IAKI,8BAA8B;AAClC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,mBAAmB;AACvB;;;AAGA;IACI,oCAAoC;IACpC,mBAAmB;IACnB,YAAY;IACZ,2CAA2C;AAC/C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,6BAA6B;AACjC;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,uBAAuB;IACvB,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,eAAe;AACnB;AACA;IACI,YAAY;IACZ,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;AACA;IACI,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;IACvB,sBAAsB;IACtB,6BAA6B;AACjC;AACA;IACI,eAAe;IACf,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;IACvB,sBAAsB;AAC1B;AACA;IACI,qBAAqB;AACzB;AACA;IACI,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;;;GAGG;;AAEH;IACI,YAAY;AAChB;;;AAGA;IACI,aAAa;IACb,uBAAuB;;AAE3B;AACA;IACI,qBAAqB;IACrB,mBAAmB;AACvB;;;AAGA;IACI,YAAY;IACZ,gBAAgB;AACpB","sourcesContent":[".LoginBg,\n.ResetBg,\n.ForgotBg,\n.SignUpBg {\n    background-size: cover;\n    width: 100%;\n    min-height: 100vh;\n}\n\n.LoginBg>div,\n.ResetBg>div,\n.ForgotBg>div,\n.SignUpBg>div,\n.user-profile {\n    min-height: calc(100vh - 68px);\n}\n\n.signupimgbg {\n    background: rgba(20, 118, 255, .1);\n}\n\n.card {\n    border-radius: 15px;\n}\n\n\n.phone-selectr{\n    border: 1px solid rgb(233, 234, 243);\n    border-radius: 30px;\n    padding: 5px;\n    box-shadow: rgb(233, 234, 243) 0px 0px 10px;\n}\n\n.FormDiv>input ::-ms-reveal {\n    display: block !important;\n}\n\n.Forgot {\n    font-style: normal;\n    font-weight: 500;\n    font-size: 13px;\n    margin-bottom: 5px;\n    border: none;\n    background-color: transparent;\n}\n\n.Password {\n    border: 1px solid black;\n    border-radius: 30px;\n    padding: 5px;\n    overflow: hidden;\n    width: 100%;\n}\n\n.Password>input {\n    border: none;\n    background: transparent;\n    width: 86%;\n}\n\n.Password>button {\n    border: none;\n    background: transparent;\n}\n\n.Password>input:focus {\n    border: none;\n    outline: none;\n}\n\n.auth-error {\n    font-size: 12px;\n    font-weight: 600;\n}\n.nav-item > label {\n    font-size: 14px;\n}\n.Button {\n    border: none;\n    background-color: #1476FF;\n    color: #ffffff;\n    text-align: center;\n    width: 100%;\n    margin-top: 20px;\n    padding: 7px 0px;\n    border-radius: 45px;\n}\n\n.Button:disabled {\n    opacity: 0.5;\n}\n\n.OtpInputBox {\n    display: flex;\n    justify-content: center;\n}\n.OtpInputBox>input {\n    border-radius: 10px;\n    border: 1px solid black;\n    height: 50px !important;\n    width: 50px !important;\n    -webkit-text-security: square;\n}\n.OtpInputBox1>input {\n    font-size: 20px;\n    border-radius: 10px;\n    border: 1px solid black;\n    height: 40px !important;\n    width: 40px !important;\n}\n.resize:active {\n    transform: scale(0.5);\n}\n.nav-item > .active {\n    font-weight: 600;\n    color: black !important;\n}\n\n/* .logindiv{\n    border: none!important;\n\n} */\n\n.logindiv > div div:nth-child(2) > div{\n    padding: 0px;\n}\n\n\n.restricted-modal > .modal-dialog{\n    display: flex;\n    justify-content: center;\n    \n}\n.restricted-modal > .modal-dialog > .modal-content{\n    width: 85% !important;\n    border-radius: 30px;\n}\n\n\n.css-f6d81q-control{\n    border: none;\n    box-shadow: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
